import React from 'react'
import styled from 'styled-components'

import Angle from '../../../atoms/Angle'
import OuterLink from '../../../atoms/OuterLink'

const Item = styled.li`
  border-bottom: 1px solid ${({ theme }) => theme.palette.border.light};
  box-sizing: border-box;
  padding: 15px 10px 15px 15px;
  position: relative;
`

const ItemLink = styled(OuterLink)`
  display: flex;
  text-decoration: none;
`

const ItemText = styled.span`
  color: ${({ theme }) => theme.palette.font.link};
  flex: 1;
  font-size: 12px;
`

const ItemAngle = styled(Angle)`
  width: 24px;
  height: 24px;
  margin-right: auto;
`

export default function MenuItem({ text, to }: { text: string; to: string }) {
  return (
    <Item>
      <ItemLink to={to}>
        <ItemText>{text}</ItemText>
        <ItemAngle color="pink" direction="right" />
      </ItemLink>
    </Item>
  )
}
